export enum WorkOrderStatus {
  Open = "OPEN",
  InProgress = "IN_PROGRESS",
  AwaitingParts = "AWAITING_PARTS",
  Ready = "READY",
  Delivered = "DELIVERED",
}
